"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAgentInputSchema = exports.createAgentInputSchema = exports.agentMetaSchema = exports.agentSchema = void 0;
const zod_1 = require("zod");
exports.agentSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500),
    systemPrompt: zod_1.z.string(),
    icon: zod_1.z.string().optional(),
    orgId: zod_1.z.string(),
    creatorId: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.agentMetaSchema = exports.agentSchema.pick({
    id: true,
    name: true,
    description: true,
    icon: true,
    creatorId: true,
    createdAt: true,
});
exports.createAgentInputSchema = exports.agentSchema.pick({
    name: true,
    description: true,
    systemPrompt: true,
    icon: true,
});
exports.updateAgentInputSchema = exports.createAgentInputSchema.partial();
